import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TaskType } from '../models/task-type.model';
import { ToastMachineService } from './toast-machine.service';

@Injectable({
  providedIn: 'root'
})
export class TaskTypeService {

  types: TaskType[] = [];

  constructor(
    private http: HttpClient,
    private toaster: ToastMachineService
  ) { }

  getTypes(): Promise<TaskType[]> {
    return new Promise((resolve, reject) => {
      this.http.get<TaskType[]>(environment.apiURL + '/task_types').subscribe(
        (data) => {
          this.types = data;
          resolve(this.types);
        },
        (err) => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        }
      );
    });
  }

  getType(id: number): Promise<TaskType> {
    return new Promise((resolve, reject) => {
      this.http.get<TaskType>(environment.apiURL + '/task_type/' + id).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(error);
        }
      );
    });
  }

  postType(type: TaskType): Promise<TaskType> {
    return new Promise((resolve, reject) => {
      this.http.post<TaskType>(environment.apiURL + '/task_type', type).subscribe(
        (data) => {
          this.getTypes();
          resolve(data);
        },
        (err) => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(error);
        }
      );
    });
  }

  putType(type: TaskType): Promise<TaskType> {
    return new Promise((resolve, reject) => {
      this.http.put<TaskType>(environment.apiURL + '/task_type/' + type.id, type).subscribe(
        (data) => {
          this.getTypes();
          resolve(data);
        },
        (err) => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(error);
        }
      );
    });
  }

  deleteType(id: number): Promise<TaskType> {
    return new Promise((resolve, reject) => {
      this.http.delete<TaskType>(environment.apiURL + '/task_type/' + id).subscribe(
        (data) => {
          this.getTypes();
          resolve(data);
        },
        (err) => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(error);
        }
      );
    });
  }
}
